import { Chip } from '@/components/ui'
import { daysUntil, formatDate } from '../utils/dates'

const SOON_DAYS = 60

/** Expiry date with a red chip when expired, amber within 60 days. */
export function ExpiryChip({ expiresOn }: { expiresOn: string | null }) {
  if (!expiresOn) return <span className="text-tertiary">No expiry</span>
  const days = daysUntil(expiresOn)
  if (days < 0) {
    return (
      <Chip variant="danger" dot>
        Expired {formatDate(expiresOn)}
      </Chip>
    )
  }
  if (days <= SOON_DAYS) {
    return (
      <Chip variant="warning" dot>
        {formatDate(expiresOn)} · {days === 0 ? 'today' : `${days}d`}
      </Chip>
    )
  }
  return <span>{formatDate(expiresOn)}</span>
}
